import React, { useEffect} from "react";
import { Link } from "gatsby";
import {GetPrice} from "../../common/utils/property_utils";

import ShareButton from "./ShareButton";
import { SaveItem, useUserObjectState, isAuthenticated } from "@starberry/myaccount-website-utils";
import { hasMyaccount } from "../../common/constant"

import "./DetailsInfo.scss";
import { HeartIcon } from "../../common/icons";
const DetailsInfo = ({property_data, setPlay, clickFloorplan, videoUrl}) => {

    const { state, services } = useUserObjectState()
    const authUser = isAuthenticated()
    const shareurl = typeof window !== 'undefined' ? window.location.href : ''

    useEffect(() => {
        if (authUser && hasMyaccount) {
        // on page load get the users saved objects
            services.getUserobject({ type: "property", state:true })
        }
    }, [])

    const trackerBrochure = (event) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'Download Brochure',
            'formType': event + ' - ' + shareurl,
            'formId': 'Brochure',
            'formName': 'Brochure',
            'formLabel': 'Brochure'
        });
    }

    var brochure_url = property_data?.selling_info?.publicBrochureUrl ? property_data?.selling_info?.publicBrochureUrl  : property_data?.brochure?.length > 0 ? property_data?.brochure[0]?.url : "";

    var pppw = property_data.price > 0 && parseInt(property_data.bedroom) > 0 ? GetPrice(property_data.price*12/52/property_data.bedroom)+"/PPPW" : GetPrice(property_data.price);

    return (
        <React.Fragment>
            <section className="details">
                <div className="details-wrap no_bdr">
                    <div className="details-link">
                        <div className="icon-wrapper">
                            {videoUrl && 
                            <div className="icon-wrap" onClick={() => setPlay(true)}>
                                <a href="javascript:;">
                                    <i className="video"></i>
                                </a>
                                <a href="javascript:;" className="count">Video</a>
                            </div>
                            }

                            {property_data?.floorplan?.length > 0 &&
                            <div className="icon-wrap" onClick={clickFloorplan}>
                                <a href="javascript:;">
                                    <i className="icon-floor"></i>
                                </a>
                                <a href="javascript:;" className="count">Floorplans</a>
                            </div>
                            }

                            <div className="icon-wrap sb-myacc-wrap">
                                <SaveItem type="property" pid={property_data?.id}>
                                    <div class="detail-save">
                                        <HeartIcon /><span> Save</span><span class="saved-text">d</span>
                                    </div>
                                </SaveItem>
                            </div>
                            {brochure_url && 
                                <div className="icon-wrap">
                                    <a href={brochure_url} onClick={() => trackerBrochure('Brochure')} target="_blank">
                                        <i className="brochure"></i>
                                    </a>
                                    <a href={brochure_url} onClick={() => trackerBrochure('Brochure')} target="_blank" className="count">Brochure</a>
                                </div>                            
                            }

                            <ShareButton property_data={property_data} className={(property_data?.floorplan?.length > 0 || property_data?.video_tour?.url) ? "share_icon_left" : "" } />
                        </div>
                    </div>

                    <div className="details-text">
                    {parseFloat(property_data?.price) > 0 && (
                        process.env.GATSBY_SITE_NAME === "BV Students" ?
                            <div className="h3 price">
                                From {pppw}
                            </div>
                            :
                            <div className="h3 price">
                                {GetPrice(property_data.price)}

                                {(property_data?.price_qualifier && (property_data?.price_qualifier !== "Offers in the region of" && property_data?.price_qualifier !== "Offers in excess of")) &&
                                    <span>{property_data.price_qualifier}</span>
                                }
                            </div>
                        )
                    }
                    </div>
                </div>
                    
                <div className="details-wrap">
                    <div className="details-text">
                        {property_data.display_address &&
                            <h1>{property_data.display_address}</h1>
                        }
                        <div className="icon-wrapper">
                            {parseInt(property_data.bedroom) > 0 ?
                            <div className="icon-wrap">
                                <a href="javascript:;">
                                    <i className="icon-bed"></i>
                                </a>
                                <span className="count d-md-flex"> <span className="no">{property_data.bedroom}</span>
                                <span className="d-none d-md-flex"> {parseInt(property_data.bedroom) > 1 ? "beds" : "bed"}</span> </span>
                            </div> : ""
                            }

                            {parseInt(property_data.bathroom) > 0 ?
                            <div className="icon-wrap">
                                <a href="javascript:;">
                                    <i className="icon-bath"></i>
                                </a>
                                <span className="count d-md-flex"> <span className="no"> {property_data.bathroom} </span>
                                <span className="d-none d-md-inline-block"> {parseInt(property_data.bathroom) > 1 ? "baths" : "bath"}</span> </span>
                            </div> : ""
                            }

                            {parseInt(property_data.reception) > 0 ?
                            <div className="icon-wrap">
                                <a href="javascript:;">
                                    <i className="icon-reception"></i>
                                </a>
                                <span className="count d-md-flex">
                                    <span className="no"> {property_data.reception} </span>
                                    <span className="d-none d-md-inline-block"> {parseInt(property_data.reception) > 1 ? "receptions" : "reception"}</span>
                                </span>
                            </div> : ""
                            }

                            {/* {(property_data.parking && property_data.parking.length > 0) ?
                                <div className="icon-wrap">
                                    <a href="javascript:;">
                                        <i className="icon-parking"></i>
                                    </a>
                                    <span className="count d-md-flex">
                                        <span className="d-none d-md-inline-block">Parking</span>
                                    </span>
                                </div>
                                : ""
                            } */}

                            {property_data.council_tax ?
                                <div className="icon-wrap">
                                    <a href="javascript:;">
                                        <i className="icon-house"></i>
                                    </a>

                                    <span className="count d-flex d-md-none">{property_data.council_tax}</span>
                                    <span className="d-none d-md-inline-block">Council Tax: {property_data.council_tax}</span>
                                </div> : ""
                            }

                            {property_data?.extra?.energyRate ? 
                                <div className="icon-wrap">
                                    <a href="javascript:;">
                                        <i className="icon-light"></i>
                                    </a>

                                    <span className="count d-flex d-md-none">{property_data?.extra?.energyRate}</span>
                                    <span className="d-none d-md-inline-block">EPC Rating: {property_data?.extra?.energyRate}</span>

                                </div>
                                : ""
                            }

                            {/* {process.env.GATSBY_SITE_NAME === "BV Students" &&  
                            <>
                                <div className="icon-wrap">
                                    <a href="javascript:;">
                                        <i className="icon-wifi"></i>
                                    </a>

                                    <span className="count d-flex d-md-none">100mbps</span>
                                    <span className="d-none d-md-inline-block">100mbps* wifi</span>
                                </div>

                                <div className="icon-wrap">
                                    <a href="javascript:;">
                                        <i className="icon-receipt"></i>
                                    </a>

                                    <span className="count d-flex d-md-none">Bills included</span>
                                    <span className="d-none d-md-inline-block">all bills included</span>
                                </div>
                            </>
                            } */}
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
};
export default DetailsInfo;
